import PageActions from '../actions/page';
import 'brace/mode/json';
import 'brace/theme/twilight';
import '../../css/build.less';
import '../../css/metadata-editor.less';
import React from 'react';
import Ace from 'react-ace';
import { Alert, Button, Glyphicon, Modal } from 'react-bootstrap';
import GraphSource from '../sources/graph';
import SharedSource from '../sources/shared';

class MetadataEditor extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
        this.onClearAlert = this.onClearAlert.bind(this);
        this.onHide = this.onHide.bind(this);

        this.state = {
            metadata: null,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isVisible && !prevProps.isVisible) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ isLoading: true });

            if (manywho.utils.isEqual(this.props.elementType, 'map', true) || manywho.utils.isEqual(this.props.elementType, 'group', true)) {
                GraphSource.getMapElement(this.props.id,
                    this.props.flowId,
                    this.props.editingToken,
                    this.props.elementType,
                    this.props.tenantId,
                    this.props.authenticationToken)
                    .then(response => this.setState({ metadata: JSON.stringify(response, null, 4), isLoading: false }))
                    .catch(({ message }) => {
                        this.setState({
                            isLoading: false,
                            alert: { style: 'danger', message, icon: 'exclamation-sign' },
                        });
                    });
            } else {
                SharedSource.get(this.props.id, this.props.elementType, this.props.tenantId, this.props.authenticationToken)
                    .then(response => this.setState({ metadata: JSON.stringify(JSON.parse(response), null, 4), isLoading: false }))
                    .catch(({ message }) => {
                        this.setState({
                            isLoading: false,
                            alert: { style: 'danger', message, icon: 'exclamation-sign' },
                        });
                    });
            }
        }
    }

    onChange(value) {
        this.setState({ metadata: value });
        this.onClearAlert();
    }

    onHide() {
        this.props.toggleMetadata();
        this.onClearAlert();
    }

    onClearAlert() {
        this.setState({ alert: null });
    }

    save() {
        this.setState({ isLoading: true });

        try {
            const json = JSON.parse(this.state.metadata);

            if (manywho.utils.isEqual(this.props.elementType, 'map', true) || manywho.utils.isEqual(this.props.elementType, 'group', true)) {
                GraphSource.saveMapElement(json,
                    this.props.flowId,
                    this.props.editingToken,
                    this.props.elementType,
                    this.props.tenantId,
                    this.props.authenticationToken)
                    .then(() => {
                        this.setState({
                            isLoading: false,
                            alert: { style: 'success', message: 'Map Element saved successfully', icon: 'ok' },
                        });
                        setTimeout(() => { this.onClearAlert(); }, 3000);
                    })
                    .catch(({ message }) => {
                        this.setState({
                            isLoading: false,
                            alert: { style: 'danger', message, icon: 'exclamation-sign' },
                        });
                    });
            } else {
                SharedSource.save(json, this.props.elementType, this.props.tenantId, this.props.authenticationToken)
                    .then(() => {
                        const model = manywho.model.getComponent(this.props.modelId, this.props.flowKey);
                        const pageId = manywho.utils.getObjectDataProperty(model.objectData[0].properties, 'Id').contentValue;
                        PageActions.refreshEditor(pageId);
                    })
                    .catch(({ message }) => {
                        this.setState({
                            isLoading: false,
                            alert: { style: 'danger', message, icon: 'exclamation-sign' },
                        });
                    });
            }
        } catch ({ message }) {
            this.setState({
                isLoading: false,
                alert: { style: 'danger', message, icon: 'exclamation-sign' },
            });
        }
    }

    render() {

        // flowKey if editiing within a page or flowId if within a flow
        const uniqueEditorId = this.props.flowKey || this.props.flowId;

        return (
            <Modal
                show={this.props.isVisible}
                onHide={this.onHide}
                container={this.props.container}
                bsSize="large"
                className="metadata-editor"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Metadata</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.alert && (
                        <Alert bsStyle={this.state.alert.style} onDismiss={this.onClearAlert}>
                            <Glyphicon glyph={this.state.alert.icon} />
                            <strong>
                                {' '}
                                {this.state.alert.message}
                            </strong>
                        </Alert>
                    )}
                    <Ace
                        mode="json"
                        theme="twilight"
                        value={this.state.metadata}
                        width="auto"
                        height="auto"
                        name={`metadata-editor-${uniqueEditorId}`}
                        onChange={this.onChange}
                        fontSize={16}
                    />
                    <Alert bsStyle="warning">
                        <Glyphicon glyph="warning-sign" />
                        {' Saving changes to the metadata will overwrite any un-saved changes in the editor'}
                    </Alert>
                    {this.state.isLoading && React.createElement(manywho.component.getByName('wait'), { isVisible: true }, null)}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.save}>Save</Button>
                    <Button bsStyle="default" onClick={this.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );

    }

}

export default MetadataEditor;
